import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAsyncData, setAsyncData, setUserDetails } from "../Utility/AsyncStorage"
import axios from "axios";
import { showToast } from './Toast';

import "../Styles/Login.css";
import MyImage from "../Assets/logo.png"; import OtpInput from "react-otp-input";




const Login = (e) => {

    console.log("login")
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ username: "", password: "" });
    const [otpState, setOtpState] = useState(true)
    const [otp, setOtp] = React.useState('');
    const [timer, setTimer] = useState(30);
    const [canResend, setCanResend] = useState(false);

    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        input: {
            width: '40px',
            height: '40px',
            fontSize: '20px',
            margin: '0 5px',
            textAlign: 'center',
            border: '1px solid #ccc',
            borderRadius: '5px',
        }
    };

    const handleLogin = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const generateRandomPassword = (length) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let password = '';
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    };

    const fetchPassword = async () => {

        const storedPassword = await getAsyncData('app_password');
        if (storedPassword) {
            // console.log("storedPassword if", storedPassword)
            return storedPassword
        } else {
            const newPassword = generateRandomPassword(30);

            // console.log("storedPassword else", newPassword)
            return newPassword
        }
    }

    const handleSubmit = async (e) => {
        // Prevents page reload
        // console.log("user details :- " , "user no :", formData.username, "passwprd : ", fetchPassword(), "otp: ", otp)
        if (formData.username === "") {
            console.log("Enter email / phone no.")
            showToast("Provide Login Details first", 3000, "red");
            return
        }
        if (formData.username !== "") {
            // console.log("handleSubmit")
            try {
                var password = await fetchPassword();

                let url = "https://itlapi.flovation.in/user/login";
                let body = {
                    phone: formData.username,
                    password: password,
                    otp: otp
                }
                console.log("body login", body)
                await axios.post(url, body, {
                }).then(response => {

                    if (response.status === 200) {

                        if (response.data.statusCode === 0) {
                            // console.log("statsData", response.data.op[0])

                            setAsyncData('app_password', JSON.stringify(password));
                            setUserDetails(JSON.stringify(response.data.op[0]));
                            if (response.data.op[0].role === "SUPER ADMIN" || response.data.op[0].role === "ADMIN" || response.data.op[0].role === "REGIONAL ADMIN" || response.data.op[0].role === "SUB ADMIN") {
                                navigate("/home");
                            }
                            else {
                                navigate("/machineIncharge");
                            }


                        }
                        else if (response.data.statusCode === 2) { //incorrect password
                            setOtpState(false);
                            showToast(response.data.msg, 3000, "red");
                            return
                        }
                        else {
                            console.log("statsData", response.data.msg)
                            showToast(response.data.msg, 3000, "red");
                        }

                    }
                    else {
                        showToast(response.data.msg, 3000, "red");
                    }

                }).catch(error => {
                    console.log("statsData", error)
                })
            } catch (error) {
                console.log("statsData1", error)
            }
            //  setOtpState(false)
        }

    }

    const handleResendOTP = async() => {
        setTimer(30);
        setCanResend(false);
        try {

            let url = "https://itlapi.flovation.in/user/login";
            let body = {
                phone: formData.username,
                password: "1234",
            }
            console.log("resend login", body)

            await axios.post(url, body, {
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        // console.log("statsData", response.data.op[0])

                    }
                    else if (response.data.statusCode === 2) { //incorrect password
                        setOtpState(false);
                        showToast(response.data.msg, 3000, "red");
                        return
                    }
                    else {
                        console.log("statsData", response.data.msg)
                        showToast(response.data.msg, 3000, "red");
                    }

                }
                else {
                    showToast(response.data.msg, 3000, "red");
                }

            }).catch(error => {
                console.log("statsData", error)
            })
        } catch (error) {
            console.log("statsData1", error)
        }
    };

    useEffect(() => {
        let countdown;
        if (!canResend && !otpState) {
            countdown = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(countdown);
                        setCanResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(countdown);
    }, [canResend, otpState]);

    return (
        <div className="login-wrapper">
            <div className="login-container">
                <div className="right-section">
                    <div className="form-container">

                        <img src={MyImage} alt="A descriptive text" style={{ width: "150px", height: "auto", display: "inline" }} />
                        <h2>Welcome to ITL Industries</h2>
                        <p>Sign in to continue</p>
                        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                            <div>
                                {otpState == true ? (
                                    <div>
                                        <label className="label">Phone no.</label>
                                        <input
                                            type="text"
                                            name="username"
                                            placeholder="Contact Number"
                                            value={formData.username}
                                            onChange={handleLogin}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                ) : (
                                    <div>
                                        <p>Enter your One Time password sent to {formData.username}</p>
                                        <OtpInput
                                            value={otp}
                                            onChange={setOtp}
                                            numInputs={4}
                                            renderSeparator={<span> </span>}
                                            renderInput={(props) => (
                                                <input {...props} inputMode="numeric" pattern="[0-9]*" />
                                            )}
                                            containerStyle={styles.container}
                                            inputStyle={styles.input}
                                        />

                                        <div
                                            style={{
                                                opacity: "0.8",
                                                padding: "2px",
                                                borderRadius: "10px",
                                                alignItems: "center",
                                                width: "90%",
                                                margin: "20px 5% 0px 5%",
                                            }}
                                            onClick={() => {
                                                setOtpState(true);
                                                setOtp();
                                                setFormData([]);
                                            }}
                                        >
                                            <p style={{ margin: "5px", fontSize: "13px" }}>
                                                Login with Another Contact Number
                                            </p>

                                        </div>
                                    </div>
                                )}

                                {(otpState == false) ?
                                    (canResend ? (
                                        <button onClick={handleResendOTP}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                color: '#007bff',
                                                cursor: 'pointer',
                                                textDecoration: 'underline',
                                                marginTop: '10px',
                                                opacity: 1, // default state
                                                fontSize: 12,
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.opacity = 0.8)}
                                            onMouseLeave={(e) => (e.currentTarget.style.opacity = 1)}>
                                            Resend OTP
                                        </button>
                                    ) : (
                                        <p style={{
                                            marginTop: "10px",
                                            color: timer >= 10 ? "gray" : "red",
                                            fontSize: 12,
                                        }}>
                                            Resend OTP in {timer}s
                                        </p>
                                    )) : <></>}

                                <button type="submit" className="login-button">
                                    {otpState ? "Next" : "Submit"}
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
